import { ENEMIES, SPELLS, type EnemyDef } from './content.ts';

export interface EvolutionRecipe {
  spellId: string;
  passiveId: string;
  color: string;
}

export const EVOLUTION_RECIPES: EvolutionRecipe[] = SPELLS.map((s) => ({
  spellId: s.id,
  passiveId: s.evolution.passive,
  color: s.color,
}));

export const BESTIARY_ENEMIES: EnemyDef[] = Object.values(ENEMIES).filter((e) => e.behavior !== 'static');

const REGULAR_TARGETS = [50, 250, 1000] as const;
const REGULAR_REWARDS = [35, 90, 220] as const;
const BOSS_TARGETS = [1, 3, 10] as const;
const BOSS_REWARDS = [100, 200, 400] as const;

export interface BountyInfo {
  tier: number;
  target: number;
  reward: number;
  claimable: boolean;
  maxed: boolean;
}

export function bountyMilestone(enemyId: string, kills: number, claimedTier: number): BountyInfo {
  const isBoss = ENEMIES[enemyId]?.behavior === 'boss';
  const targets = isBoss ? BOSS_TARGETS : REGULAR_TARGETS;
  const rewards = isBoss ? BOSS_REWARDS : REGULAR_REWARDS;
  const tier = Math.max(0, Math.min(3, Math.floor(claimedTier)));
  if (tier >= 3) {
    return { tier: 3, target: targets[2], reward: 0, claimable: false, maxed: true };
  }
  const target = targets[tier];
  const reward = rewards[tier];
  return {
    tier,
    target,
    reward,
    claimable: kills >= target,
    maxed: false,
  };
}

export function claimBounty(
  enemyId: string,
  bestiary: Record<string, number>,
  bounties: Record<string, number>,
): { gold: number; bounties: Record<string, number> } | null {
  const info = bountyMilestone(enemyId, bestiary[enemyId] ?? 0, bounties[enemyId] ?? 0);
  if (!info.claimable || info.maxed) return null;
  return {
    gold: info.reward,
    bounties: { ...bounties, [enemyId]: info.tier + 1 },
  };
}
